import { QueryClient } from "@tanstack/react-query";
var queryClient = new QueryClient();
export default queryClient;
//# sourceMappingURL=queryClient.js.map